import {extendTheme} from '@chakra-ui/react';
import {colors} from 'theme';

import * as components from './components';

export const config = {
  ...extendTheme({
    styles: {
      global: {
        'html, body': {
          background: colors.bodyBackground,
          height: '100%',
        },
        '#__next': {
          height: '100%',
        },
        'input:focus, textarea:focus, select:focus': {
          boxShadow: 'none !important',
        },
      },
    },
    fonts: {
      body: `var(--font-montserrat), -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif`,
      heading: `var(--font-montserrat), -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif`,
    },
    radii: {
      md: '1rem',
    },
    shadows: {
      header: '0 8px 15px rgb(54 48 48 / 15%)',
      footer: '0px -1px 10px rgba(0, 0, 0, 0.15)',
      outline: 'none',
    },
    colors: {
      palette: colors,
      pink: {
        50: '#FFF5FA',
        100: '#FFE0F0',
        200: '#FFCCE7',
        300: '#FF99D1',
        400: '#FF66BC',
        500: '#F6009B', // Main pink color from theme
        600: '#D6008B',
        700: '#B6007A',
        800: '#96006A',
        900: '#76005A',
      },
    },
    components: {
      ...components,
    },
  }),
  breakpoints: {sm: '1320px'},
};
